/** タスク編集シートのチップの表示名とクラス */

import type { TodoEnergy, TodoStatus } from '@/api/types/todo'

export const statusLabel = (s: TodoStatus) =>
  ({ pending: '未着手', in_progress: '進行中', scheduled: '予定済', done: '完了', dismissed: '却下' })[s]

export const energyLabel = (e: TodoEnergy) => ({ low: 'Low', medium: 'Mid', high: 'High' })[e]

export const chipClass = (hasValue: boolean) =>
  `inline-flex items-center gap-1 text-[11px] px-2 py-0.5 rounded-full border transition-colors cursor-pointer ${
    hasValue
      ? 'border-muted-foreground/30 text-foreground bg-muted/50 hover:bg-muted'
      : 'border-dashed border-muted-foreground/20 text-muted-foreground hover:border-muted-foreground/40'
  }`

export const chipClassBlocked = () =>
  'inline-flex items-center gap-1 text-[11px] px-2 py-0.5 rounded-full border border-orange-500/50 text-orange-600 bg-orange-500/10 cursor-pointer hover:bg-orange-500/20 transition-colors'
